import React from 'react';
var style = { flex: '1 0 auto' };
export var Content = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "flex m-0 bg-contentAreaBackgroundAlt", style: style }, children));
};
